<template lang="html">
  <v-window
    v-model="currentDashboardPageId"
    :key="currentDashboardPageId"
    continuous
  >
    <v-lazy
      v-for="page in dashboardPages"
      :key="page.id"
      :value="page.id === currentDashboardPageId"
      :options="{
        threshold: .5
      }"
      transition="fade-transition"
    >
      <v-window-item
        :value="page.id"
      >
        <!-- REFACTOR: DashboardTile should use router-link for proper HTML tags/attributes  -->
        <div class="ma-3 mx-sm-6 mx-md-6 mt-sm-8 mt-md-10" :key="`content-${page.id}`">
          <DashboardGrid
            v-slot="{ item, getColor, index }" 
            :dashboard-page="page"
            :key="`grid-${page.id}`"
          >
            <DashboardTile
              v-bind="item"
              @newTab="onClick(item, true)"
              @click="onClick(item, false)"
              :color="getColor(index)"
              :key="item.id"
            />
          </DashboardGrid>
        </div>
      </v-window-item>
    </v-lazy>
  </v-window>
</template>

<script>
import { get, call } from 'vuex-pathify';

export default {
  name: 'Dashboard',
  metaInfo() {
    return {
      title: `${this.currentDashboardPage?.name} Dashboard`,
    };
  },
  components: {
    DashboardGrid: () => import('@/components/DashboardGrid.vue'),
    DashboardTile: () => import('@/components/DashboardTile.vue')
  },
  computed: {
    ...get('user', ['currentDashboardPage', 'dashboardPages', 'currentDashboardPageUrl']),
  },
  watch: {
    currentDashboardPage: {
      immediate: true,
      handler(e) {
        this.currentDashboardPageId = e?.id;
      },
    },
    currentDashboardPageId(newId, oldId) {
      if (!newId || (newId == oldId)) return;
      this.setCurrentDashboardPageById(newId);
      this.$router.push({
        name: 'dashboard',
        params: {
          dashboardPageUrl: this.currentDashboardPageUrl,
        }
      });
    },
  },
  data() {
    return {
      currentDashboardPageId: '',
    };
  },
  methods: {
    ...call('user', [
      'setCurrentDashboardPageById',
    ]),
    onClick(dashboardTile, newTab = false) {
      // path doesn't work with params https://v3.router.vuejs.org/guide/essentials/navigation.html
      const basePath = '/' + this.$route.params.operatingCompanyUrl + '/' + this.$route.params.dashboardPageUrl;
      const path = `${basePath}/${dashboardTile.path}`;
      if (newTab) {
        if (dashboardTile.custom) {
          window.open(dashboardTile.path, '_blank');
        } else {
          let newRoute = this.$router.resolve(path); 
          window.open(newRoute.href, '_blank');
        }
      } else {
        this.$router.push(path); // tight coupliung, maybe use route names
      }      
    },
  },
};
</script>

<style lang="css" scoped></style>
